import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Loader2 } from "lucide-react";
import { format } from "date-fns";
import { fr } from "date-fns/locale";

interface ValidatedAmountCardProps {
  isLoading: boolean;
  totalAmount: number;
  periodLabel: string;
  selectedPeriod: string;
  validatedAmounts?: Array<{
    payment_method: string;
    amount: number;
    counting_date: string;
  }>;
}

export const ValidatedAmountCard = ({ 
  isLoading, 
  totalAmount, 
  periodLabel,
  selectedPeriod,
  validatedAmounts = []
}: ValidatedAmountCardProps) => {
  const today = new Date();
  const formattedDate = format(today, "dd/MM/yyyy", { locale: fr });

  return (
    <Card>
      <CardHeader>
        <CardTitle>
          {selectedPeriod === "day" 
            ? `Aujourd'hui le ${formattedDate}`
            : `Chiffre d'affaires validé pour ${periodLabel}`
          }
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="flex justify-center items-center p-4">
            <Loader2 className="h-6 w-6 animate-spin" />
          </div>
        ) : (
          <div className="space-y-4">
            <div className="text-2xl font-bold text-orange-500">
              {totalAmount.toLocaleString()} FCFA
            </div>
            <p className="text-sm text-muted-foreground">
              {selectedPeriod === "day" 
                ? "Ce montant restera affiché jusqu'à minuit"
                : `Ce montant représente le total validé pour ${periodLabel}`
              }
            </p>

            {validatedAmounts.length > 0 && (
              <div className="mt-6 space-y-3">
                <h4 className="font-medium text-sm">Détail des montants comptés :</h4>
                <div className="space-y-2">
                  {validatedAmounts.map((amount, index) => (
                    <div 
                      key={index} 
                      className="flex justify-between items-center py-2 border-b last:border-0"
                    >
                      <div>
                        <span className="font-medium">{amount.payment_method}</span>
                        <div className="text-sm text-muted-foreground">
                          {format(new Date(amount.counting_date), "dd/MM/yyyy", { locale: fr })}
                        </div>
                      </div>
                      <span className="font-medium">
                        {amount.amount.toLocaleString()} FCFA
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
};